import selectVideo from '../../../shared/video_contents/selectVideo'
import directUploadVideoFile from '../../../shared/directUploadVideoFile'

export default function() {
  selectVideo();
  directUploadVideoFile('/creator/video_contents/execute_presigned_post');
};
